import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker só em produção: em desenvolvimento o cache serviria o bundle
// anterior a cada edição de código. O catch silencioso é proposital — navegador
// sem suporte ou registro recusado não pode impedir o painel de abrir.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
